export function canvasQueryEnabled(
  externalId: string | undefined,
  isPreviewMode: boolean,
  authIsLoading: boolean,
): boolean {
  return Boolean(externalId && (isPreviewMode || !authIsLoading));
}
